import Base from "../base";

export default class EncuestaCompletaServices extends Base {
  static endpointUrl = "encuestas/usuario_empresa/";
}
